import { io } from "socket.io-client";

let sockets = new Map();

export function getSocket(service) {
  if (!sockets.has(service)) {
    const host = process.env.NODE_ENV === 'development' ? 'http://integrify.demo' : location.host;
    
    sockets.set(service, io(host, {
      transports: ["websocket"],
      upgrade: false,
      path: `/api/${service}/socket.io`,
    }));

    sockets.get(service).on('connect', () => {
      console.log(`[WebSocket: ${service}] Connected successfully! Socket ID: ${sockets.get(service).id}`);
    });
  }

  return sockets.get(service);
}
